<template>
  <div class="container client">
    <div style="color:black">
      专题页
    </div>
    <el-card style="margin-top: 20px;">
      <div style="display:flex; justify-content: space-between;"> <el-form class="search-wrap"
                 ref="searchForm"
                 :inline="true"
                 :model="query"
                 size="small"
                 label-position="left">
          <el-form-item label="标题">
            <el-input v-model.trim="query.comb_keyword"
                      placeholder="请输入标题"
                      @input="getList(true)"
                      clearable></el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary"
                   class="button"
                   size=""
                   style="height:40px"
                   @click="handleCreate()">新建专题</el-button>
      </div>
    </el-card>
    <el-card style="margin-top: 20px">
      <div class="card-header">
        <h3 class="title">专题列表</h3>
      </div>
      <el-table :data="results"
                :header-cell-style="{
          textAlign: 'center',
        }"
                @selection-change="handleSelectionChange"
                border>
        <el-table-column type="selection"
                         width="50"
                         fixed="left"
                         align="center"></el-table-column>
        <el-table-column type="index"
                         width="70"
                         label="序号"
                         align="center">
        </el-table-column>
        <el-table-column label="标题"
                         align="center"
                         min-width="300"
                         show-overflow-tooltip
                         prop="title">

        </el-table-column>
        <el-table-column label="访客UV"
                         align="center"
                         min-width="100"
                         show-overflow-tooltip
                         prop="total_visitor_count">

        </el-table-column>
        <el-table-column label="浏览量PV"
                         align="center"
                         min-width="100"
                         show-overflow-tooltip
                         prop="total_browse_count">
        </el-table-column>

        <el-table-column align="center"
                         label="有效期"
                         width="300">
          <template slot-scope="scope">
            {{scope.row.start_time?$moment(scope.row.start_time).format("YYYY-MM-DD HH:mm"):""}}- {{scope.row.end_time?$moment(scope.row.end_time).format("YYYY-MM-DD HH:mm"):""}}
          </template>
        </el-table-column>

        <el-table-column align="center"
                         label="创建时间"
                         width="150">
          <template slot-scope="scope">
            {{scope.row.create_time?$moment(scope.row.create_time).format("YYYY-MM-DD HH:mm"):""}}
          </template>
        </el-table-column>
        <el-table-column align="center"
                         label="更新时间"
                         width="150">
          <template slot-scope="scope">
            {{scope.row.update_time?$moment(scope.row.update_time).format("YYYY-MM-DD HH:mm"):""}}
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="150"
                         align="center">
          <template slot-scope="scope">
            <div class="link-wrap">
              <el-link type="primary"
                       :underline="false"
                       @click="handleToEdit(scope.row)">编辑</el-link>
              <el-link type="primary"
                       :underline="false"
                       @click="handleToConcat(scope.row)">关联</el-link>
              <div class="badge-content">
                <el-link type="primary"
                         :underline="false"
                         @click="handleToDetail(scope.row.id)">浏览</el-link>
              </div>

              <!-- <el-link type="danger"
                       :underline="false"
                       @click="handleToChangeStatus(scope.row.id)">删除</el-link> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 16px"
           class="footer">
        <div class="left">
          <span>已选 {{chooseList.length}} 条</span>
          <span class="xian"></span>
          <span style="marginRight:16px">批量</span>
          <p class="batch"
             @click="handleDelete()">删除</p>
        </div>

        <div class="block">
          <el-pagination background
                         layout="total, prev, pager, next, sizes, jumper"
                         :current-page="Number(query.pageIndex)"
                         :page-sizes="[10, 20, 50, 100, 500]"
                         :page-size="Number(query.pageSize)"
                         :total="Number(pageTotal)"
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"></el-pagination>

          <DetailLookSync :isVisible="lookDetailVisible"
                          @close="lookDetailClose"
                          :noteId="themmID"
                          :type="typeTheme" />
          <Relevance :visible="relevanceVisible"
                     :concatDetail="concatDetail"
                     @close="close()" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import DetailLookSync from '@/components/dialog/DetailLookSync'
import { themePageList, themePageDelete } from '@/api/senior'
import { manageUrl } from '@/utils/helper.js'
import Relevance from '@/components/dialog//senior/relevance'

export default {
  components: { DetailLookSync, Relevance },
  data() {
    return {
      concatDetail: {},
      typeTheme: '主题',
      themmID: null,
      relevanceVisible: false,
      lookDetailVisible: false,
      TableName: '专题列表',
      results: [],
      createDialog: false,
      query: {
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
      },
      pageTotal: 0,
      chooseList: [],
      editDialog: false,
      editId: null,
      refuseVisible: false,
      create_time: '',
      end_time: '',
      reason: '',
      reasonDialog: false,
      filters: {
        statuses: [
          { label: '等待审核', value: 0 },
          { label: '正在进行', value: 1 },
          { label: '审核驳回', value: 2 },
          { label: '任务结束', value: 3 },
          { label: '任务取消', value: 4 },
        ],
        types: [
          { label: '辅导推荐', value: 1 },
          { label: '资料制作', value: 2 },
          { label: '讲座答疑', value: 3 },
          { label: '课程分销', value: 4 },
          { label: '其他综合', value: 5 },
        ],
      },
    }
  },
  created() {
    this.getList()
  },
  watch: {},
  computed: {},
  methods: {
    close() {
      this.relevanceVisible = false
    },
    lookDetailClose() {},
    handleCreate() {
      this.$router.push(`/senior/topicCreate`)
    },
    handleSizeChange(val) {
      this.query.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.query.pageIndex = val
      this.getList()
    },
    getList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      const params = Object.assign({}, this.query)

      if (isReset) {
        this.query.pageIndex = 1
      }
      themePageList(params).then((res) => {
        this.results = res.list
        this.pageTotal = res.count
      })
    },
    handleSelectionChange(val) {
      this.chooseList = val
    },
    formateType(val) {
      let types = {
        1: '辅导推荐',
        2: '资料制作',
        3: '讲座答疑',
        4: '课程分销',
        5: '其他综合',
      }
      return types[val]
    },
    handleToConcat(row) {
      this.concatDetail = row
      this.relevanceVisible = true
    },
    handleToEdit(row) {
      this.themmID = row.id
      this.$router.push(`/senior/topicEdit/${row.id}`)
    },
    handleDelete() {
      if (this.chooseList.length == 0) {
        this.$message.error('还没有选择要删除的数据')
        return
      }
      this.$confirm('确定要删除这些信息吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let ids = this.chooseList.map((v) => {
          return v.id
        })

        themePageDelete({ ids }).then((res) => {
          this.$message.success('删除成功')
          this.getList()
        })
      })
    },
    handleToAccept(is_accept, id) {
      this.$confirm('确定要通过吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        taskcheck({
          id: id,
          is_access: is_accept,
        }).then((res) => {
          this.getList()
        })
      })
    },
    RefuseDialogSubmit({ text }) {
      taskcheck({
        id: this.editId,
        is_access: 0,
        refuse_reason: text,
      }).then((res) => {
        this.getList()
      })
    },
    openRefuseDialog(id) {
      this.refuseVisible = true
      this.editId = id
    },
    openreason(row) {
      this.reason = row.refuse_reason
      this.reasonDialog = true
    },
    handleToDetail(id) {
      this.lookDetailVisible = true
      // this.$router.push(`/senior/task/${id}`)
    },
    handleToChangeStatus(id) {
      this.$confirm('确定要取消任务吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let str = manageUrl()
        // @@@@@@@
        this.$axios({
          url: `${str}/api/v1/seniorWork/taskRoom/task`,
          method: 'put', //可以省略 不写默认是get
          data: {
            id: id,
            status: 4,
          },
          headers: {
            // 设置请求头
            Authorization: localStorage.getItem('admin_token'),
          },
        }).then((response) => {
          let res = response.data
          if (res.code == 0) {
            this.getList()
          }
        })
      })
    },
  },
}
</script>

<style lang="less" scoped>
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;

      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
    }
  }
}
.el-link {
  font-size: 12px;
  margin: 0px 5px;
}
.el-tag {
  margin: 0px 5px;
}
.tag-wrap {
  text-align: left;
}
.card-header {
  margin-bottom: 16px;
}
.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left {
    display: flex;
    align-items: center;
    .xian {
      margin-left: 16px;
      margin-right: 16px;
      width: 1px;
      height: 20px;
      background: #dcdfe6;
      border-radius: 0px 0px 0px 0px;
    }
    .batch {
      text-align: center;
      font-weight: 400;
      font-size: 13px;
      color: #f56c6c;
      width: 46px;
      height: 26px;
      line-height: 26px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #f56c6c;
    }
  }
}
.link-wrap {
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.left {
  width: 100%;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.badge-content {
  position: relative;
  .badge {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #f56c6c;
    color: #fff;
    font-size: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: -5px;
    top: -2px;
  }
}
</style>
